import { gql } from '@apollo/client';

export const EXPORT_SCHOOL_EDUCATOR = gql`
  query ExportSchoolEducator($input: ExportArgs!) {
    exportSchoolEducator(input: $input) {
      id
      name
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subjects {
        id
        name
        subjectGradeReference
      }
      schoolEducator {
        id
        year
        term
        circuit {
          id
          name
        }
        district {
          id
          name
        }
        emisNumber
        educatorName
        attendanceRate
        daysAbsent
        institution {
          id
          emisNumber
          name
        }
      }
    }
  }
`;
